module.exports = __webpack_public_path__ + "media/images/Logo_ClimatePartner_Color-fc7ca0e2ba85cb2ff584a6fa3b76586e.png";